/**
 * Execution Cockpit V6 Design Tokens
 *
 * Re-exports from the global HELIX Professional Design System v9.2.1 (Executive OS).
 * This ensures the Daily Brief uses the canonical theme.
 *
 * Migration note: Previously used "Stock Taper" (warm cream/orange).
 * Now uses Executive OS (cool gray/muted blue).
 */

import {
  t as globalT,
  ragColors as globalRagColors,
  severityColors as globalSeverityColors,
  urgencyColors as globalUrgencyColors,
  confidenceColors as globalConfidenceColors,
  evidenceStatusColors as globalEvidenceStatusColors,
} from '@/theme';

// Map global theme to local token structure for backward compatibility
export const tokens = {
  colors: {
    // Backgrounds
    bg: globalT.bg,
    card: globalT.surface,
    cardMuted: globalT.bgSubtle,
    cardDark: globalT.bgMuted,

    // Borders
    border: globalT.border,
    borderLight: globalT.borderLight,

    // Text
    text: globalT.text,
    textSecondary: globalT.textSecondary,
    textMuted: globalT.textMuted,

    // Primary accent (was orange, now muted blue)
    accent: globalT.primary,
    accentLight: globalT.primaryLight,
    accentBorder: globalT.primaryMedium,

    // RAG colors
    green: globalT.green,
    greenLight: globalT.greenLight,
    greenBorder: globalT.greenBorder,

    red: globalT.red,
    redLight: globalT.redLight,
    redBorder: globalT.redBorder,

    amber: globalT.amber,
    amberLight: globalT.amberLight,
    amberBorder: globalT.amberBorder,

    // Additional colors
    blue: globalT.blue,
    blueLight: globalT.blueLight,
    blueBorder: globalT.blueBorder,

    purple: globalT.purple,
    purpleLight: globalT.purpleLight,
    purpleBorder: globalT.purpleBorder,
  },
} as const;

// Convenience alias
export const c = tokens.colors;

// Type exports
export type TokenColors = typeof tokens.colors;
export type ColorKey = keyof TokenColors;

// Re-export semantic color mappings from global theme
export const ragColors = globalRagColors;
export const severityColors = globalSeverityColors;
export const urgencyColors = globalUrgencyColors;
export const confidenceColors = globalConfidenceColors;
export const evidenceStatusColors = globalEvidenceStatusColors;

// Export the full theme for components that need it
export { helixTheme } from '@/theme';
